import React, { useEffect, useState } from 'react';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import * as styles from '../styles/recentProjects.module.scss';
import { getRecentProjects } from '../services/projects';
import Spinner from 'react-bootstrap/Spinner';

function RecentProjects({ heading, description }) {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getRecentProjects().then((res) => {
      if (res.data.projects.project && res.data.projects.project.length > 0) {
        setProjects(res.data.projects.project);
      }
    });
  }, []);
  return (
    <section className={styles.recentProjects}>
      <hr width="50%" />
      <h2>{heading}</h2>
      <p>{description}</p>

      {projects.length === 0 ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          slidesPerView={1}
          spaceBetween={30}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop
          breakpoints={{
            700: { slidesPerView: 3 },
            1160: { slidesPerView: 4 },
          }}
        >
          {projects &&
            projects.map((project, i) => (
              <SwiperSlide key={i}>
                <div className={`card ${styles.recentProject}`}>
                  <h4>{`${project.name['_text'].substring(0, 50)} - ${
                    project.location['_text']
                  }`}</h4>
                  <p>{project.description['_text']}</p>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </section>
  );
}
export default RecentProjects;
